import { Button } from '@teko/ds-foundation';
import { ClockAlternativeOutlined, CalendarOutlined, DeleteCircleFilled, ArrowDownTinyFilled, BackOutlined, ForwardOutlined, JumpBackOutlined, JumpForwardOutlined } from '@teko/ds-icon';
import Picker from 'rc-picker-minimal';
import dateFnsConfigs from 'rc-picker-minimal/lib/generate/dateFns';
import enLocale from 'rc-picker-minimal/lib/locale/en_US';
import React from 'react';
import { Wrapper } from './style.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CustomButton = (props) => /* @__PURE__ */ React.createElement(Button, __spreadValues({
  size: "s"
}, props), "Xong");
const DateTimePicker = (_a) => {
  var _b = _a, {
    value,
    format,
    onChange = () => {
    },
    type = "date",
    placeholder,
    disabledDate,
    disabledTime,
    showTime,
    prefix,
    hidePrefix = false,
    suffix,
    borderRadius = "s",
    dropdownBorderRadius,
    width = "fit-content"
  } = _b, rest = __objRest(_b, [
    "value",
    "format",
    "onChange",
    "type",
    "placeholder",
    "disabledDate",
    "disabledTime",
    "showTime",
    "prefix",
    "hidePrefix",
    "suffix",
    "borderRadius",
    "dropdownBorderRadius",
    "width"
  ]);
  let configs;
  configs = {
    generateConfig: dateFnsConfigs,
    locale: enLocale,
    prevIcon: /* @__PURE__ */ React.createElement(BackOutlined, null),
    nextIcon: /* @__PURE__ */ React.createElement(ForwardOutlined, null),
    superPrevIcon: /* @__PURE__ */ React.createElement(JumpBackOutlined, null),
    superNextIcon: /* @__PURE__ */ React.createElement(JumpForwardOutlined, null)
  };
  switch (type) {
    case "time":
      configs = __spreadProps(__spreadValues({}, configs), {
        picker: "time",
        placeholder: placeholder || "00:00:00",
        format: format || "HH:mm:ss"
      });
      break;
    case "datetime":
      configs = __spreadProps(__spreadValues({}, configs), {
        showTime: true,
        placeholder: placeholder || "dd/mm/yyyy hh:mm:ss",
        format: format || "dd/MM/yyyy HH:mm:ss"
      });
      break;
    default:
      configs = __spreadProps(__spreadValues({}, configs), {
        picker: "date",
        placeholder: placeholder || "dd/mm/yyyy",
        format: format || "dd/MM/yyyy"
      });
  }
  return /* @__PURE__ */ React.createElement(Wrapper, __spreadValues({
    borderRadius,
    dropdownBorderRadius,
    width
  }, rest), !hidePrefix && (prefix !== void 0 ? prefix : type === "time" ? /* @__PURE__ */ React.createElement(ClockAlternativeOutlined, {
    size: 24
  }) : /* @__PURE__ */ React.createElement(CalendarOutlined, {
    size: 24
  })), /* @__PURE__ */ React.createElement(Picker, __spreadProps(__spreadValues({}, configs), {
    style: { width: "100%" },
    onChange: (val) => {
      onChange(val);
    },
    value,
    allowClear: true,
    clearIcon: /* @__PURE__ */ React.createElement(DeleteCircleFilled, {
      size: 20,
      onClick: (e) => {
        e.stopPropagation();
        onChange(void 0);
      }
    }),
    suffixIcon: !value && (suffix !== void 0 ? suffix : /* @__PURE__ */ React.createElement(ArrowDownTinyFilled, null)),
    showToday: true,
    components: {
      button: CustomButton
    },
    dropdownAlign: {
      offset: [-36, 12]
    },
    getPopupContainer: (triggerNode) => triggerNode,
    disabledDate,
    disabledTime,
    showTime
  })));
};

export { DateTimePicker };
